export default "__VITE_ASSET__hUwNBcEf__"